export default "__VITE_ASSET__DL$mUOui__"